import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { WeeklyHours } from "./OpenHours";
import { useLang } from "../../lib/lang";
import { INFO } from "../../lib/content";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#1a0508] pb-28 pt-16 text-white/80 md:pb-12">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-5 md:flex-row md:items-end md:justify-between lg:px-10">
        <div>
          <Logo light />
          <p className="mt-4 text-sm">{t.footer.tagline}</p>
        </div>
        <div className="space-y-1 text-sm">
          <p>{INFO.address}</p>
          <a data-testid="footer-phone-link" href={INFO.phoneHref} className="flex items-center gap-2 hover:text-white"><Phone size={14} /> {INFO.phone}</a>
        </div>
        <WeeklyHours light />
        <p className="text-xs text-white/70">© 2026 Levantisk Bord. {t.footer.rights}</p>
      </div>
    </footer>
  );
};

export const MobileBar = () => {
  const { t } = useLang();
  return (
    <div data-testid="mobile-order-bar" className="fixed inset-x-3 bottom-3 z-50 flex gap-2 rounded-full bg-[#1a0508]/90 p-1.5 shadow-2xl backdrop-blur-xl md:hidden">
      <a data-testid="mobile-call-button" href={INFO.phoneHref} className="flex flex-1 items-center justify-center gap-2 rounded-full py-3 text-sm font-medium text-white"><Phone size={16} /> {t.mobile.call}</a>
      <a data-testid="mobile-order-button" href={INFO.phoneHref} className="flex flex-1 items-center justify-center rounded-full bg-[#721121] py-3 text-sm font-semibold text-white">{t.mobile.order}</a>
    </div>
  );
};
